export enum HapticPattern
{
  LIGHT = "light",
  MEDIUM = "medium",
  HEAVY = "heavy"
}

export interface HapticStrength
{
  amplitude: number;
  duration: number;
}

export const HAPTIC_STRENGTH: Record<HapticPattern, HapticStrength> = {
  [HapticPattern.LIGHT]: { duration: 15, amplitude: 130 },
  [HapticPattern.MEDIUM]: { duration: 15, amplitude: 130 },
  [HapticPattern.HEAVY]: { duration: 15, amplitude: 130 },
};

export const HAPTIC_MAPPING: Readonly<Record<string, HapticPattern>> = {
  "ui_click": HapticPattern.LIGHT,

  "glass_cube_drop_1": HapticPattern.LIGHT,
  "glass_cube_drop_2": HapticPattern.LIGHT,
  "wood_cube_drop_1": HapticPattern.LIGHT,
  "wood_cube_drop_2": HapticPattern.LIGHT,

  "metal_cube_hit": HapticPattern.HEAVY,
  "wood_cube_hit": HapticPattern.MEDIUM,
  "cannon_shot": HapticPattern.HEAVY,

  "search_level": HapticPattern.LIGHT,
  "start_level": HapticPattern.MEDIUM,
  "lose_game": HapticPattern.HEAVY,
  "win_game": HapticPattern.MEDIUM,
};
